import React, { Component } from 'react';
import './App.css';
import './dropdown.css';
import logo from './logo-36.png';
import Sticky from 'react-sticky-el';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Col, Container, Hidden, Row } from 'react-grid-system';
import { remHexHash, textColor } from '../../utilis';
import HexList from '../Hexlist/HexList';
import DropdownMenu from 'react-dd-menu';
import links from '../../data/links';
import { Helmet } from "react-helmet";
import ClipBoard from 'clipboard';
// import colorNames from '../../data/color-to-name';
import isUndefined from 'lodash.isundefined';

const clipboard = new ClipBoard('.btn'); // eslint-disable-line no-unused-vars

class App extends Component {
  constructor() {
    super();
    this.state = { pageBGColor: `#FFFFFF`, isMenuOpen: false };

    if (window.location.pathname.length === 7) {
      const directLinkColor = window.location.pathname.replace("/","#");
      this.state = { pageBGColor: directLinkColor, isMenuOpen: false  };
    } 
    this.toggle = this.toggle.bind(this);
    this.close = this.close.bind(this);
}


toggle() {
  this.setState({ isMenuOpen: !this.state.isMenuOpen });
}

close() {
  this.setState({ isMenuOpen: false });
}

sendToApp = code => {
  this.setState({
      pageBGColor: `#${code}`
    }
  )
}

  render() {
    const menuOptions = {
      isOpen: this.state.isMenuOpen,
      close: this.close,
      toggle: <span className="linkButton" onClick={this.toggle}>More tools by JOE Apple</span>,
      align: 'center'
    };
    
    const bgClr = isUndefined(this.state.pageBGColor) ? '#ffffff' : this.state.pageBGColor;
    return (
      <Router>
        <div className="App" style={{backgroundColor: bgClr }}>
          <Helmet>
            <link rel="canonical" href={`http://hexcodes.link/${remHexHash(bgClr)}`} />
          </Helmet>
        <Container fluid style={{paddingLeft:'0',paddingRight:'0'}}>
          <Row>
            <Col className="header" style={{outline:0,backgroundColor: bgClr}} md={12}>
                <Sticky style={{zIndex:300}}>
                  <Row style={{paddingLeft:'15px',paddingRight:'15px'}}>
                    <Col style={{outline:0,backgroundColor: bgClr}} md={6} xs={7}>
                      <div className="header" style={{paddingTop: '10px', backgroundColor: bgClr }}>
                        <img src={logo} alt="Logo" /> <a href="http://hexcodes.link" className="header-logo" style={{color: textColor(remHexHash(bgClr))}}>Hexcodes.link</a>
                      </div>
                    </Col>
                    <Col style={{outline:0,backgroundColor: bgClr}} md={6} xs={5}>
                      <div className="headerLink" style={{ backgroundColor: this.state.pageBGColor }}>
                        <DropdownMenu {...menuOptions}>
                        {
                          links.map((link, i) => 
                              <li key={i}><a href={link.url}>{link.display}</a></li>
                          )
                        }
                        </DropdownMenu>
                      </div>
                    </Col>
                    <Col style={{outline:0,backgroundColor: bgClr}} md={12}>  
                    <div className="header" style={{paddingTop: '10px', backgroundColor: bgClr }}>
                        <p className="infotext well" style={{color: textColor(remHexHash(bgClr))}}>
                        Click on one of the hexcodes below to change the page background. </p>
                        <span className="changewith" style={{color: textColor(remHexHash(bgClr))}}><u>Sample Text</u>
                        </span>&nbsp;<input id="foo" style={{width: '55px', borderRadius: '4px'}} value={bgClr} readOnly />
                        <button className="btn" data-clipboard-target="#foo" style={{cursor: 'pointer'}}> Copy</button>
                        <p className="infotext bl">Lorem ipsum dolor sit amet, consectetur adipiscing elit.<Hidden xs> Fusce eget commodo erat. Nullam sit amet arcu at nibh sagittis feugiat sed ut metus. Phasellus ornare facilisis luctus.</Hidden></p>
                        <p className="infotext wh">Lorem ipsum dolor sit amet, consectetur adipiscing elit.<Hidden xs> Fusce eget commodo erat. Nullam sit amet arcu at nibh sagittis feugiat sed ut metus. Phasellus ornare facilisis luctus.</Hidden></p>
                    </div>
                    </Col>
                  </Row>
                </Sticky>
              </Col>
          </Row>
          <Route exact path="/" render={props => <HexList sendToApp = { this.sendToApp } />}  />
          <Route path="/:hex" render={props => <HexList sendToApp = { this.sendToApp } />} />
          <Row style={{paddingLeft:'15px',paddingRight:'15px'}}>
            <Col className="bottom"
                  style={{outline:0,background:'rgba(0, 0, 0, 0)',color: textColor(remHexHash(bgClr))}}>
              <h2>About</h2>
              I originally built a page to show the contrast between two background and text colors. I extended here it to include all 216 websafe colors. 
            </Col>
          </Row>
          <Row style={{paddingLeft:'15px',paddingRight:'15px'}}>
            <Col className="bottom" style={{outline:0,background:'rgba(0, 0, 0, 0)'}} md={4} sm={12}>
            <script async src="//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>
            <ins className="adsbygoogle"
                // style="display:block" // eslint-disable-line react/style-prop-object
                data-ad-client="ca-pub-6345235116680072"
                data-ad-slot="3961627985"
                data-ad-format="auto"
                data-full-width-responsive="true"></ins>
            <script>
            (adsbygoogle = window.adsbygoogle || []).push({});
            </script>
            </Col>
            <Col className="bottom" style={{outline:0,background:'rgba(0, 0, 0, 0)'}} md={4} sm={12}>
            <script async src="//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>
<ins className="adsbygoogle"
     // style="display:block" // eslint-disable-line react/style-prop-object
     data-ad-client="ca-pub-6345235116680072"
     data-ad-slot="3961627985"
     data-ad-format="auto"
     data-full-width-responsive="true"></ins>
<script>
(adsbygoogle = window.adsbygoogle || []).push({});
</script>
            </Col>
            <Col className="bottom" style={{outline:0,background:'rgba(0, 0, 0, 0)'}} md={4} sm={12}>
            <script async src="//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>
<ins className="adsbygoogle"
     // style="display:block" // eslint-disable-line react/style-prop-object
     data-ad-client="ca-pub-6345235116680072"
     data-ad-slot="3961627985"
     data-ad-format="auto"
     data-full-width-responsive="true"></ins>
<script>
(adsbygoogle = window.adsbygoogle || []).push({});
</script>
            </Col>
          </Row>
        </Container>
        </div>
      </Router>
    );
  }
}
export default App;


// WEBPACK FOOTER //
// ./src/components/App/App.js